












import Vue from 'vue';
import { snakeCase } from 'lodash';

export default Vue.extend({
  name: 'RiskScoreCellPresenter',
  computed: {
    showRiskScore() {
      const scores = this.$attrs.row.riskScores;
      const type = this.$attrs.column.key;
      if (!scores) {
        return '';
      }
      return scores.find(score => snakeCase(score.title) === type).score || '';
    },
  },
});
